module.exports = __webpack_public_path__ + "static/mac-449179c402cace6ababa16cb134c3536.png";